import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Card, CardActionArea, CardContent, CardMedia } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import LinkProduct from './LinkProduct'

const useStyles = makeStyles((theme) => ({
	showcase : {
		display: "flex",
		justifyContent: "center",
	},
  root: {
    maxWidth: 290,
		minWidth: 290,
		margin: "1em 0",
		display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
		
		"& .MuiCardContent-root" : {
			background: "white"
		},
		
		"& .MuiCardMedia-img" : {
			height: "200px"
		},
		
		[theme.breakpoints.down(600)] : {
			maxWidth: "85%",
			minWidth: "85%",
		}
  },
	prizeArea : {
		display:"flex", 
		alignItems:"center", 
		justifyContent:"left",
		padding: "0 0 30px",
	},
	iconGrid : {
		display: "flex",
		justifyContent: "center",
		fontSize: 10,
		alignItems: "center",
		cursor: "default"
	},
}))

const ShowcaseCard = (props) => {
  const classes = useStyles()

  var numberFormat = new Intl.NumberFormat('es-ES')

  return (
		<Grid item xs={12} sm={6} md={4} style={{display: "flex", justifyContent: "center"}}>
			<Card className={classes.root}>
				<CardActionArea onClick={() => window.scrollTo(0, 0)}>
					<LinkProduct codOferta={props.codOferta} codInmobiliaria={props.codInmobiliaria}>
						{props.img !== "" ? 
							<CardMedia
								component="img"
								alt="Imagen de Producto"
								image={props.img}
							/>
							: 
							<div style={{height:200, background: "white", display: "flex", alignItems: "center", justifyContent: "center"}}>
								<Typography variant="subtitle1">
                	<svg x="0px" y="0px" width="130" height="130" viewBox="0 0 172 172" style={{fill: "#000000"}}><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{mixBlendMode: "normal"}}><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#b9b9b9"><path d="M46.44,32.68c-11.3786,0 -20.64,9.2614 -20.64,20.64v65.36c0,11.3786 9.2614,20.64 20.64,20.64h79.12c11.3786,0 20.64,-9.2614 20.64,-20.64v-65.36c0,-11.3786 -9.2614,-20.64 -20.64,-20.64zM46.44,36.12h79.12c9.5194,0 17.2,7.6806 17.2,17.2v65.36c0,9.5194 -7.6806,17.2 -17.2,17.2h-79.12c-9.5194,0 -17.2,-7.6806 -17.2,-17.2v-65.36c0,-9.5194 7.6806,-17.2 17.2,-17.2zM46.44,41.28c-6.63954,0 -12.04,5.40046 -12.04,12.04v43.73906c-0.01517,0.09232 -0.01517,0.1865 0,0.27883v21.34211c0,6.63954 5.40046,12.04 12.04,12.04h69.53906c0.09232,0.01517 0.1865,0.01517 0.27883,0h9.30211c6.63954,0 12.04,-5.40046 12.04,-12.04v-7.57539c0.01667,-0.09671 0.01667,-0.19556 0,-0.29227v-18.79234c0.00439,-0.31015 -0.15856,-0.59863 -0.42645,-0.75498c-0.26789,-0.15635 -0.59921,-0.15635 -0.8671,0c-0.26789,0.15635 -0.43084,0.44484 -0.42645,0.75498v16.84391l-21.39922,-21.39922c-0.97495,-0.97495 -2.26117,-1.46469 -3.54078,-1.46469c-1.27961,0 -2.56583,0.48974 -3.54078,1.46469l-16.23922,16.23922l-28.27922,-28.27922c-0.97495,-0.97495 -2.26117,-1.46469 -3.54078,-1.46469c-1.27961,0 -2.56583,0.48974 -3.54078,1.46469l-19.67922,19.67922v-41.78391c0,-5.71006 4.60994,-10.32 10.32,-10.32h71.38c0.31015,0.00439 0.59863,-0.15856 0.75498,-0.42645c0.15635,-0.26789 0.15635,-0.59921 0,-0.8671c-0.15635,-0.26789 -0.44484,-0.43084 -0.75498,-0.42645zM114.38,55.04c-3.08167,0 -5.50069,1.18659 -7.09164,2.97641c-1.59095,1.78982 -2.36836,4.14248 -2.36836,6.48359c0,2.34111 0.77741,4.69378 2.36836,6.48359c1.59095,1.78982 4.00998,2.97641 7.09164,2.97641c5.21443,0 9.46,-4.24557 9.46,-9.46c0,-5.21443 -4.24557,-9.46 -9.46,-9.46zM114.38,56.76c4.28487,0 7.74,3.45513 7.74,7.74c0,4.28487 -3.45513,7.74 -7.74,7.74c-2.65167,0 -4.53264,-0.96341 -5.80836,-2.39859c-1.27572,-1.43518 -1.93164,-3.38252 -1.93164,-5.34141c0,-1.95889 0.65592,-3.90622 1.93164,-5.34141c1.27572,-1.43518 3.15669,-2.39859 5.80836,-2.39859zM136.72656,70.50656c-0.22809,0.00356 -0.44542,0.09758 -0.60418,0.26138c-0.15876,0.1638 -0.24595,0.38397 -0.24238,0.61205v3.44c-0.00439,0.31015 0.15856,0.59863 0.42645,0.75498c0.26789,0.15635 0.59921,0.15635 0.8671,0c0.26789,-0.15635 0.43084,-0.44484 0.42645,-0.75498v-3.44c0.00364,-0.23275 -0.08721,-0.45703 -0.25181,-0.62163c-0.1646,-0.1646 -0.38888,-0.25545 -0.62163,-0.25181zM59.34,75.68c0.84287,0 1.6794,0.31549 2.32469,0.96078l28.76633,28.76633c0.06522,0.09788 0.14983,0.18135 0.24859,0.24523l23.3443,23.34766h-67.58391c-5.71006,0 -10.32,-4.60994 -10.32,-10.32v-21.14391l20.89531,-20.89531c0.64529,-0.64529 1.48181,-0.96078 2.32469,-0.96078zM136.72656,79.10656c-0.22809,0.00356 -0.44542,0.09758 -0.60418,0.26138c-0.15876,0.1638 -0.24595,0.38397 -0.24238,0.61205v6.88c-0.00439,0.31015 0.15856,0.59863 0.42645,0.75498c0.26789,0.15635 0.59921,0.15635 0.8671,0c0.26789,-0.15635 0.43084,-0.44484 0.42645,-0.75498v-6.88c0.00364,-0.23275 -0.08721,-0.45703 -0.25181,-0.62163c-0.1646,-0.1646 -0.38888,-0.25545 -0.62163,-0.25181zM110.94,87.72c0.84287,0 1.6794,0.31549 2.32469,0.96078l22.61531,22.61531v7.38391c0,5.71006 -4.60994,10.32 -10.32,10.32h-9.10391l-24.08,-24.08l16.23922,-16.23922c0.64529,-0.64529 1.48181,-0.96078 2.32469,-0.96078z"></path></g></g></svg>
								</Typography>
							</div>
						}
						<CardContent>
							<Typography variant="body2" color="textPrimary" component="p">
								{props.titulo}
							</Typography>
						</CardContent>
					</LinkProduct>
				</CardActionArea>
				<CardContent style={{padding:"0 16px 10px"}}>
					<span className={classes.prizeArea}> 
						<Typography variant="h6" color="primary" component="p" style={{fontWeight:"bold", margin:"0 5px"}}>
							{props.importe <= 1 
								? "Consultar precio"
								: props.moneda +" "+ numberFormat.format(props.importe)
							}
						</Typography>
						{(props.importe > 1 && props.operacion === "Alquiler") ? <span>/mensual</span> : ""} 
					</span>
					
					<div style={{display: "flex"}}>
						<img alt="" height="20" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAADyUlEQVRoge2ZTUhVQRSAP61XPvP1Y0REC6MkCwwr+l0pRUHQKtRqUavaRCBKtJOgoNrUpkjKrZW1qRYtjSCNCO2XoD+IIgsrUlH70fK1mHMbeb377sx9c99z0QeXgZkz55y598zfufCfyUWBY30JYDuwCagCFgGzpW0AeAM8Bm4BN4Ehx/azZgHQAowAScNnBGgFyvPg7z/EgaPAMMq5caAbaAZqgApghjzLpK5ZZMalzyhwEpieY9//Ug48QQ+gHVhq0X8pcAU9oC5gvmMfA1kJ9IkDr4C1WehaB7wWXe+Ayqy9M6QcPYgOoNSBzrmoBSAJvCUHXyaODqcOIOZQdww9mC4injNH0eHk4kukMhcdZici0A+oJXYYNTmzmRNBrBcbP4ElURhoQb2pdst+MexD8KrYumDZL5AEagMbx26JrQaeylNt0a9CbA0DJRb9AtmNekPdhvILgDb0HuHtNW3SZkKP9Ku38jSAVlHaHCA3FWgEBkV+CDgkz5DUDYrM1ABdR0T+fGiv03BflNZkkPHCyPsCl4GFE9oXSp3XHhRum0TuXmiv0/BZlPrNj1Z0GD0TJzI5+Awdbq0+chUi02fiYNDn9Zgp5Uef9l70lWAlMJZB1y2RGZU+vT5yH6ScZeijEd9Qb6fYpz2ODhlTPPm4T3uxtH8zUVZoaPSrlH67+Xef+tQ7iE3feVJ+CfQO84F4cbrIUN4FZVJ+MhE2HcgjKddYuxMez9ZDE2HTgTyQcqO1O+HZkGLbCctQMT4ATPORSTcPMs2RTPMmBvSTeckPzStRvMWn3TTpYLIAbJW2F6bOmYYWwDUp91r0CcueFJtO8U6k34E5URgQZqHTSsujMtIpBg5HZQB1wEwCdyK0Qb0Y+Yzje4JQhDqaJIHaCPT/ZQrwUgw1RaC/UXS/FluRsl+MfcT/nBSGiV9jn0O9vsTQX6XBod6D6CXX9FSeNbvQc8VFWmgOOum304E+YwqA22K4xYG+s+iVyvWvjkAqUZej36hcVFhWAb9Ql7EqB36F4jQ6u2JzSvAoAO6KjlMO/bImgbqqJoEDIfp7K2Cv6MordejUz2KLfmXotFFdBH6FwkvzdGK2kRWiM++XIvTLmlJ0iDUayDeI7HuiyepnxRbU6fgHsDqD3ApUZmQc2JYDv0JxDr07pztUlgDPReZMDv2ypgiVLEgCF9O0t0lbD3n8i2tKOepun3pCbpK6fuxWt7xSi5oDY8Bmecakbkce/QrFcfTB0kuCH8urRyEpBG6gsyXXCXeMmRQkUP837jEJjiD/ySV/AGsVGKHhaKZ7AAAAAElFTkSuQmCC" />
					
						<Typography variant="caption" style={{marginLeft:5, textTransform: "uppercase"}}>
                            {props.ubicacion}
						</Typography>
					</div>

					<div style={{display: "flex"}}>
						<img alt="" height="20" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAByUlEQVRoge2WO07DQBBAH4iG5CIoiOPQklS0nIWSKhFHgSAhEChBQtyBmlDQmMYJ47C7nv3lY+2TLDme8ez8HSgUCoXCHjAAXoGX+j6H/eeM9gG4AL6Aqr6+gcs9sk8fGIsDxobf/cz2exH2ATgB3jBnSGbwAzjbQfsAjIShd8w9O6hlVa07MshtPR9if+gTwDFww19pb3G3jk3f1vOp7Ds5xZ1hFzLDn9h7fimLsW+r4EpxoVF0cC4cXm8F6UhV6/ribLU+MKGZwZAtlGKmNJi2XA/gSTysAg3LRExwJ6JncCQkcdLnR4ApMCMsEDlTC/wyPETZ8xaW/s6AO5NAS+7vSBtWf7WBBK3DFnvXAfaiAlnP4JXSWQ2+FQ4OJNlfBgc+reYdSOpWakN7nncgses5lH/r1SIH4FBh8AeYJ3EtjHntg5q2jG+rIiq5piJ7QWwgDzR7WV73HromfS8OxH1leEaLvK3VfHSj/DlSGNewfpjLaZNj0bPXmRkxVWSTm0mDyh9ZkWkmR3KyWhC2QTKRathdM+Iz7A1iZ8RVxah1mpPYL7vrfZPM67zObK0SyK7RmUBC1u+mSb5+t/HB3NkVXigUCoVu8QtwPQszQW2UQAAAAABJRU5ErkJggg==" />
					
						<Typography variant="caption" style={{marginLeft:5, textTransform: "capitalize"}}>
                            {props.direccion}
						</Typography>
					</div>

					{/* <Grid container>
						<Grid item xs={3} className={classes.iconGrid}>
							<ProductIcon id="m2total" info="45m2" />
						</Grid>
						<Grid item xs={3} className={classes.iconGrid}>
							<ProductIcon id="m2cubierta" info="40m2" />
						</Grid>
						<Grid item xs={3} className={classes.iconGrid}>
							<ProductIcon id="ambientes" info="2" />
						</Grid>
						<Grid item xs={3} className={classes.iconGrid}>
							<ProductIcon id="baños" info="1" />
						</Grid>
					</Grid> */}
				</CardContent>
			</Card>
		</Grid>
  )
}

export default ShowcaseCard